module.exports = __webpack_public_path__ + "2f2d1b45b39268aa102dd0464c7f2484.jpg";